import Color from 'color';

const slateBlue = Color('#0C121C');
const darkCoolGrey = Color('#4A4F54');
const mediumGrey = Color('#E9ECEC');
const extraLightGrey = Color('#F8F9F9');
const lrGreen = Color('#005A2B');
const lrRedDark = Color('#B81F1F');

const colors = {
	slateBlue,
	darkCoolGrey,
	mediumGrey,
	extraLightGrey,
	lrGreen,
	lrRedDark,
};

export default colors;
